import dayjs, { ManipulateType } from 'dayjs';
import React, { ChangeEvent } from 'react';

import { FormHelperText } from '../../form-helper-text/form-helper-text';
import { Input } from '../../input/input';
import { Select } from '../../select/select';
import { DateFilterComponent, FilterPeriod } from '../date-filter.types';

export const getHelperText = (period: string | undefined, periodQuantity: number | undefined): string => {
  if (!period || !periodQuantity) {
    return '';
  }
  const today = dayjs().format('MMM D, YYYY');
  const end = dayjs()
    .subtract(periodQuantity, period as ManipulateType)
    .format('MMM D, YYYY');
  return `From ${end} to ${today}`;
};

export const DateFilterWithin: React.FC<DateFilterComponent> = ({ dateError, filter, onChange }) => {
  const selectOptions = [
    { value: 'days', label: 'days' },
    { value: 'weeks', label: 'weeks' },
    { value: 'months', label: 'months' },
    { value: 'years', label: 'years' },
  ];
  const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value.length === 0) {
      onChange({ periodQuantity: undefined });
      return;
    }
    onChange({ periodQuantity: Number.parseInt(value) });
  };
  const helperText = getHelperText(filter.period, filter.periodQuantity);
  return (
    <div className="pb-2 pl-10.5">
      <div className="flex flex-row">
        <span className="pr-4">
          <Input
            type="number"
            containerSize="large"
            onChange={onInputChange}
            value={filter.periodQuantity}
            // Pass in the error border manually, since the flex-col layout
            // will mess with the layout of the error text if we pass errorProps
            className={dateError?.period === undefined ? 'w-24' : 'w-24 border-red-600'}
          />
        </span>
        <span className="w-43">
          <Select
            allowClear={false}
            data={selectOptions}
            onChange={(e) => {
              onChange({ period: e?.value as FilterPeriod | undefined });
            }}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSearch={() => {}}
            autoSort={false}
            value={filter.period}
            containerSize="large"
            width={'172px'}
          />
        </span>
      </div>
      <FormHelperText type={'helper'} display={helperText} visible={helperText.length > 0} />
      <FormHelperText type={'error'} display={dateError?.period} visible={dateError?.period !== undefined} />
    </div>
  );
};

export default DateFilterWithin;
